const ENDPOINT = 'REPLACEsongrequest';
var REPLACE_REQUEST_ACTIONS;
(function (REPLACE_REQUEST_ACTIONS) {
    REPLACE_REQUEST_ACTIONS["check_for_existing_request"] = "check_for_existing_request";
    REPLACE_REQUEST_ACTIONS["discard_existing_request"] = "discard_existing_request";
})(REPLACE_REQUEST_ACTIONS || (REPLACE_REQUEST_ACTIONS = {}));
function replaceSongRequest(gateway, params = { songid: '' }) {
    return gateway.get(replaceSongRequest.endpoint, params);
}
replaceSongRequest.endpoint = ENDPOINT;

export { REPLACE_REQUEST_ACTIONS, replaceSongRequest as default };
//# sourceMappingURL=replaceSongRequest.js.map
